var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2017_9692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 7C1.27539 3.13401 4.4094 0 8.27539 0H42.2754C46.1414 0 49.2754 3.13401 49.2754 7V41C49.2754 44.866 46.1414 48 42.2754 48H8.27539C4.4094 48 1.27539 44.866 1.27539 41V7Z",
    fill: "#F7D4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2754 23C27.7754 23 29.9004 22.6083 31.6504 21.825C33.4004 21.0417 34.2754 20.1 34.2754 19C34.2754 17.9 33.4004 16.9583 31.6504 16.175C29.9004 15.3917 27.7754 15 25.2754 15C22.7754 15 20.6504 15.3917 18.9004 16.175C17.1504 16.9583 16.2754 17.9 16.2754 19C16.2754 20.1 17.1504 21.0417 18.9004 21.825C20.6504 22.6083 22.7754 23 25.2754 23ZM25.2754 25.5C25.9587 25.5 26.8129 25.4292 27.8379 25.2875C28.8629 25.1458 29.8504 24.9167 30.8004 24.6C31.7504 24.2833 32.5671 23.8708 33.2504 23.3625C33.9337 22.8542 34.2754 22.2333 34.2754 21.5V24C34.2754 24.7333 33.9337 25.3542 33.2504 25.8625C32.5671 26.3708 31.7504 26.7833 30.8004 27.1C29.8504 27.4167 28.8629 27.6458 27.8379 27.7875C26.8129 27.9292 25.9587 28 25.2754 28C24.5921 28 23.7379 27.9292 22.7129 27.7875C21.6879 27.6458 20.7004 27.4167 19.7504 27.1C18.8004 26.7833 17.9837 26.3708 17.3004 25.8625C16.6171 25.3542 16.2754 24.7333 16.2754 24V21.5C16.2754 22.2333 16.6171 22.8542 17.3004 23.3625C17.9837 23.8708 18.8004 24.2833 19.7504 24.6C20.7004 24.9167 21.6879 25.1458 22.7129 25.2875C23.7379 25.4292 24.5921 25.5 25.2754 25.5ZM25.2754 30.5C25.9587 30.5 26.8129 30.4292 27.8379 30.2875C28.8629 30.1458 29.8504 29.9167 30.8004 29.6C31.7504 29.2833 32.5671 28.8708 33.2504 28.3625C33.9337 27.8542 34.2754 27.2333 34.2754 26.5V29C34.2754 29.7333 33.9337 30.3542 33.2504 30.8625C32.5671 31.3708 31.7504 31.7833 30.8004 32.1C29.8504 32.4167 28.8629 32.6458 27.8379 32.7875C26.8129 32.9292 25.9587 33 25.2754 33C24.5921 33 23.7379 32.9292 22.7129 32.7875C21.6879 32.6458 20.7004 32.4167 19.7504 32.1C18.8004 31.7833 17.9837 31.3708 17.3004 30.8625C16.6171 30.3542 16.2754 29.7333 16.2754 29V26.5C16.2754 27.2333 16.6171 27.8542 17.3004 28.3625C17.9837 28.8708 18.8004 29.2833 19.7504 29.6C20.7004 29.9167 21.6879 30.1458 22.7129 30.2875C23.7379 30.4292 24.5921 30.5 25.2754 30.5Z",
    fill: "#D32778"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2017_9692",
    x: 0.275391,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2017_9692"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2017_9692",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataicon);
export default __webpack_public_path__ + "static/media/data+icon.f365d6a7138a2746c9624e9d8df97936.svg";
export { ForwardRef as ReactComponent };